import { CommonFunctions } from "../static/common-functions";
import { DispatchNoteBus } from "./DispatchNoteBus";
import { CnstContractBus } from "./CnstContractBus";
import { RelatedJobBus } from "./RelatedJobBus";

export class CnstContractSaveParam extends CnstContractBus {
    constructor(data: CnstContractBus) {
        super(data);
    }
    notes: DispatchNoteBus[];
}
